"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var React = require("react");
var Text_st_css_1 = require("./Text.st.css");
var constants_1 = require("./constants");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.render = function () {
        var _this = this;
        var _a = this.props, typography = _a.typography, tagName = _a.tagName, children = _a.children, className = _a.className, role = _a.role, id = _a.id;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile;
            return React.createElement(tagName || constants_1.DEFAULT_TAG_NAME, {
                className: Text_st_css_1.st(Text_st_css_1.classes.root, {
                    typography: typography,
                    mobile: mobile,
                }, className),
                'data-hook': _this.props['data-hook'],
                role: role,
                id: id,
            }, children);
        }));
    };
    Text.contextType = TPAComponentsConfig_1.TPAComponentsContext;
    Text.displayName = 'Text';
    Text.defaultProps = {
        typography: constants_1.TYPOGRAPHY.runningText,
    };
    return Text;
}(React.Component));
exports.Text = Text;
//# sourceMappingURL=Text.js.map